/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */
import {css} from 'lit-element';
export const styles = css`mwc-button{--mdc-theme-primary:red;--mdc-button-disabled-ink-color:aqua;--mdc-shape-small:0 4px 4px 0;--mdc-button-horizontal-padding: 5px;--mdc-button-outline-width: 2px}mwc-button[outlined]{--mdc-theme-primary:red;--mdc-button-outline-color:blue;--mdc-button-disabled-outline-color:orange;--mdc-shape-small:0 4px 4px 0}mwc-button[raised],mwc-button[unelevated]{--mdc-theme-primary:red;--mdc-button-disabled-fill-color:green;--mdc-theme-on-primary:black;--mdc-button-disabled-ink-color:aqua;--mdc-shape-small:0 4px 4px 0}`;
